export const inputValidateState = {methods: {
        ValidateState( ref ) {
            return ( this.veeFields !== undefined && this.veeFields[ref] && this.veeFields[ref].valid );
        }
    }
}
